import { SchemaBooleanExpression } from "@redotech/redo-flows-core-schema-common/expressions";
import { DeepPartialExcept } from "@redotech/util/type";

type Expression = DeepPartialExcept<SchemaBooleanExpression, "field">;

/**
 * The operands belong to the type being left behind, so a reset drops them.
 * `field` names the variable itself and outlives any of them.
 */
const variableOnly = (expression: Expression): Pick<Expression, "field"> => ({
  field: expression.field,
});

/** Selecting a variable resets the expression, so a mismatch starts empty. */
export const textMatch = (e: Expression) =>
  e.type === "text_match" ? e : variableOnly(e);
export const numberComparison = (e: Expression) =>
  e.type === "number_comparison" ? e : variableOnly(e);
export const booleanEvaluation = (e: Expression) =>
  e.type === "boolean_evaluation" ? e : variableOnly(e);
export const arrayPredicate = (e: Expression) =>
  e.type === "array_predicate" ? e : variableOnly(e);
export const checkoutContextPredicate = (e: Expression) =>
  e.type === "checkout_context_predicate" ? e : variableOnly(e);
